"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.StepTravelDate = void 0;
const react_1 = __importDefault(require("react"));
const react_intl_1 = require("react-intl");
const classFunctions_1 = require("../../../utils/classFunctions");
const Button_1 = require("../../Button");
const Sub_1 = require("../../Page/Title/Sub");
const legacy_1 = require("../../Tabs/legacy");
const FlightConfig_1 = require("./FlightConfig");
const PassengersConfig_1 = require("./PassengersConfig");
require("./index.scss");
const className = 'travel-date-form';
class StepTravelDate extends react_1.default.PureComponent {
    constructor() {
        var _a;
        super(...arguments);
        this.state = {
            airportsToList: this.props.airportList,
            ...StepTravelDate.getInitialState(),
            ...this.props.reservationData,
            travelType: (_a = this.props.reservationData.travelType) !== null && _a !== void 0 ? _a : 'return',
        };
        this.handleSubmitButton = (event) => {
            event.preventDefault();
            const { dateRange, flightMainAirports, flightOtherAirports, passengersConfig, travelType, } = this.state;
            this.props.onSubmit({
                dateRange,
                flightMainAirports,
                flightOtherAirports,
                passengersConfig,
                travelType,
            });
        };
        this.handleDateRangeChange = (key, value) => {
            this.setState((oldState) => {
                return {
                    dateRange: {
                        ...oldState.dateRange,
                        [key]: value,
                    },
                };
            });
        };
        this.handleFlightMainAirportsChange = (flightMainAirports) => {
            this.setState({ flightMainAirports });
        };
        this.handleFlightOtherAirportsChange = (flightOtherAirports) => {
            this.setState({ flightOtherAirports });
        };
        this.handlePassengersConfigChange = (passengersConfig) => {
            this.setState({ passengersConfig });
        };
        this.handleTabChange = (openedTabIndex) => {
            this.setState({
                travelType: StepTravelDate.getTravelTypeByIndex(openedTabIndex),
            });
        };
        this.getSubmitButtonEnableState = () => {
            const { flightMainAirports, flightOtherAirports, dateRange, passengersConfig, travelType, } = this.state;
            const isPassengersConfigFilled = (passengersConfig.adult + passengersConfig.child) > 0;
            const outboundFlightFilled = !!flightMainAirports.from
                && !!flightMainAirports.to
                && !!dateRange.from
                && isPassengersConfigFilled;
            if (travelType === 'one-way') {
                return outboundFlightFilled;
            }
            if (travelType === 'return') {
                return outboundFlightFilled && !!dateRange.to;
            }
            if (travelType === 'other-return') {
                const returnFlightFilled = !!flightOtherAirports.from
                    && !!flightOtherAirports.to;
                return returnFlightFilled && outboundFlightFilled && !!dateRange.to;
            }
            return false;
        };
    }
    static getInitialState() {
        return {
            dateRange: {
                from: undefined,
                to: undefined,
            },
            flightMainAirports: {
                from: undefined,
                to: undefined,
            },
            flightOtherAirports: {
                from: undefined,
                to: undefined,
            },
            passengersConfig: {
                adult: 1,
                child: 0,
                infant: 0,
            },
            travelType: 'return',
        };
    }
    static getTravelTypeByIndex(openedTabIndex) {
        // `travelType` using index of the tabs from render function to define value
        return openedTabIndex === 1 ? 'one-way'
            : (openedTabIndex === 2 ? 'other-return'
                : 'return');
    }
    static getIndexByTravelType(travelType) {
        return travelType === 'one-way' ? 1
            : travelType === 'other-return' ? 2
                : 0;
    }
    componentDidUpdate(prevProps, prevState, snapshot) {
        const flightMainAirports = this.props.reservationData.flightMainAirports;
        const isBlankFlightMainAirportsState = !this.state.flightMainAirports.to && !this.state.flightMainAirports.from;
        if (!!flightMainAirports && isBlankFlightMainAirportsState) {
            this.setState({
                ...this.state,
                flightMainAirports,
            });
        }
    }
    render() {
        const { airportList, airportsAvailabilityMap, modificators, } = this.props;
        const { flightMainAirports, flightOtherAirports, dateRange, passengersConfig, travelType, } = this.state;
        const isSubmitButtonDisabled = !this.getSubmitButtonEnableState();
        const classNames = (0, classFunctions_1.getClassNames)(className, modificators);
        return (react_1.default.createElement("div", { className: classNames },
            react_1.default.createElement("div", { className: `${className}__container` },
                react_1.default.createElement(Sub_1.PageSubTitle, { icon: 'airplane', text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/Page:title', defaultMessage: 'Travel Dates' }) }),
                react_1.default.createElement(legacy_1.LegacyTabs, { activeTab: StepTravelDate.getIndexByTravelType(travelType), tabs: [
                        {
                            title: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/FlightTab/Return:title', defaultMessage: 'Return Trip' })),
                            content: react_1.default.createElement(react_1.default.Fragment, null),
                        },
                        {
                            title: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/FlightTab/OneWay:title', defaultMessage: 'One Way' })),
                            content: react_1.default.createElement(react_1.default.Fragment, null),
                        },
                        {
                            title: (react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate/FlightTab/OtherReturn:title', defaultMessage: 'Different Return Cities' })),
                            content: react_1.default.createElement(react_1.default.Fragment, null),
                        },
                    ], modificators: ['sub'], onTabChange: this.handleTabChange }),
                react_1.default.createElement(FlightConfig_1.FlightConfig, { airportList: airportList, airportsAvailabilityMap: airportsAvailabilityMap, flightMainAirports: flightMainAirports, flightOtherAirports: flightOtherAirports, dateRange: dateRange, travelType: travelType, onDateRangeChange: this.handleDateRangeChange, onFlightMainAirportsChange: this.handleFlightMainAirportsChange, onFlightOtherAirportsChange: this.handleFlightOtherAirportsChange }),
                react_1.default.createElement(PassengersConfig_1.PassengersConfig, { passengersConfig: passengersConfig, onChange: this.handlePassengersConfigChange })),
            react_1.default.createElement("div", { className: `${className}__button` },
                react_1.default.createElement(Button_1.Button, { disabled: isSubmitButtonDisabled, icon: 'search', onClick: this.handleSubmitButton, text: react_1.default.createElement(react_intl_1.FormattedMessage, { id: 'components/Reservation/StepTravelDate:SearchButton', defaultMessage: 'Search flights' }) }))));
    }
}
exports.StepTravelDate = StepTravelDate;
StepTravelDate.defaultProps = {
    airportList: [],
    onSubmit: (data) => {
        console.log('form data:', data);
    },
    reservationData: {},
};
//# sourceMappingURL=index.js.map